import React from 'react'
import PropTypes from 'prop-types'
import './Badge.css'

/**
 * Badge Component
 *
 * Displays status or category labels with visual styling.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Badge content
 * @param {string} props.variant - Badge variant (primary, secondary, success, warning, danger, info)
 * @param {string} props.size - Badge size (small, medium)
 * @param {React.ReactNode} props.icon - Optional icon to display before text
 * @param {string} props.className - Additional CSS classes
 */
const Badge = ({
	children,
	variant = 'secondary',
	size = 'medium',
	icon,
	className = '',
}) => {
	const baseClass = 'badge'
	const classes = [
		baseClass,
		`${baseClass}--${variant}`,
		`${baseClass}--${size}`,
		className,
	]
		.filter(Boolean)
		.join(' ')

	return (
		<span className={classes}>
			{icon && <span className={`${baseClass}__icon`}>{icon}</span>}
			<span className={`${baseClass}__text`}>{children}</span>
		</span>
	)
}

Badge.propTypes = {
	children: PropTypes.node.isRequired,
	variant: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'warning',
		'danger',
		'info',
	]),
	size: PropTypes.oneOf(['small', 'medium']),
	icon: PropTypes.node,
	className: PropTypes.string,
}

export default Badge
